import { Box, Typography } from "@outschool/backpack";
import { useTranslation } from "@outschool/localization";
import * as Time from "@outschool/time";
import React from "react";

import { useTimeZone } from "../../providers/TimeZoneProvider";

interface EnrollmentManagerOneOnOneDescriptionProps {
  upcomingMeetingCount: number;
  completedMeetingCount?: number;
  enrollmentStartDate: Date;
}

export const EnrollmentManagerOneOnOneDescription = ({
  upcomingMeetingCount,
  completedMeetingCount,
  enrollmentStartDate,
}: EnrollmentManagerOneOnOneDescriptionProps) => {
  const { t } = useTranslation(
    "client\\components\\EnrolledClass\\EnrollmentManagerOneOnOneDescription",
  );
  const { timeZone } = useTimeZone();
  return (
    <Box
      flex
      sx={{
        flexDirection: "column",
        gap: "0.5em",
      }}
    >
      <Typography>
        {t("Upcoming meeting(s): ")}
        <Typography
          sx={{
            fontWeight: "fontWeightBold",
          }}
        >
          {upcomingMeetingCount}
        </Typography>
      </Typography>
      {completedMeetingCount !== undefined && (
        <Typography>
          {t("Completed meeting(s): ")}
          <Typography
            sx={{
              fontWeight: "fontWeightBold",
            }}
          >
            {completedMeetingCount}
          </Typography>
        </Typography>
      )}
      <Typography>
        {t("Enrolled: ")}
        <Typography
          sx={{
            fontWeight: "fontWeightBold",
          }}
        >
          {Time.startDayShortStringWithYear(enrollmentStartDate, timeZone)}
        </Typography>
      </Typography>
    </Box>
  );
};
